<template>
    <div class="infinity-list">
        <div class="gradient-start"></div>
        <div class="background-list"></div>
        <slot></slot>
        <div style="height: 30vh" v-intersect.quiet="onLoadNext" v-if="next_page && next_page !== 1"
             class="pt-5 text-center subtitle-1 text--secondary">

            <v-progress-circular
                    indeterminate
                    size="30"
                    width="2"
                    color="dark">
            </v-progress-circular>

        </div>
    </div>
</template>

<script>
    export default {
        name: "InfinityLoad",
        props: {
            next_page: {
                required: true,
            }
        },
        methods: {
            onLoadNext(entries, observer, isIntersecting) {
                if (this.next_page && isIntersecting) {
                    this.$emit('loadnext');
                }
            }
        }
    }
</script>

<style scoped>

    .infinity-list {
        background: rgb(237,238,240);
        background: linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(237,238,240,1) 400px, rgba(237,238,240,1) calc(100% - 200px), rgba(255,255,255,1) 100%);
        padding-bottom: 70px;
    }

    /*.infinity-list {*/
    /*    background: rgb(237, 238, 240);*/
    /*}*/
    /*.background-list {*/
    /*    position: absolute;*/
    /*    top: 400px;*/
    /*    width: 100%;*/
    /*    height: 100%;*/
    /*    background: rgb(237, 238, 240);*/
    /*}*/
    /*.gradient-start {*/
    /*    position: absolute;*/
    /*    width: 100%;*/
    /*    height: 400px;*/
    /*    background: rgb(237, 238, 240);*/
    /*    background: linear-gradient(0deg, rgba(237, 238, 240, 1) 0%, rgba(237, 238, 240, 1) 50%, rgba(255, 255, 255, 1) 100%);*/
    /*}*/
</style>